export const logErrorConstants = {
  LOG_ERROR_LIST_REQUEST: 'LOG_ERROR_LIST_REQUEST',
  LOG_ERROR_LIST_SUCCESS: 'LOG_ERROR_LIST_SUCCESS',
  LOG_ERROR_LIST_FAILURE: 'LOG_ERROR_LIST_FAILURE',
  LOG_ERROR_LIST_CHANGED: 'LOG_ERROR_LIST_CHANGED',
  LOG_ERROR_LIST_PAGINATION: 'LOG_ERROR_LIST_PAGINATION',

};
